import React from 'react';

function Terms() {
    return (
        <div className="terms-black-theme">
          

            <p className="terms-text">
                Welcome to <span className="gold-accent">Albuquerque Press Club</span>!
            </p>

            <p className="terms-text">
                These terms and conditions outline the rules and regulations for the use of the 
                Albuquerque Press Club <span className="teal-accent">Application</span> or Website.
            </p>

            <p className="terms-text">
                By using this application you <span className="gold-accent">accept</span> these terms and conditions. 
                Do not continue to use Albuquerque Press Club if you do not agree to take all of the 
                terms and conditions stated on this page.
            </p>

            <h3 className="meta-label-lg gold-accent">Cookies</h3>
            <p className="terms-text">
                We employ the use of <span className="teal-accent">cookies</span>. By accessing the site, 
                you agreed to use cookies in agreement with the Privacy Policy. 
            </p>

            <h3 className="meta-label-lg gold-accent">License</h3>
            <p className="terms-text">
                Unless otherwise stated, we and/or our licensors own the 
                <span className="teal-accent"> intellectual property rights</span> for all material. 
                All rights are reserved.
            </p>

            <ul className="terms-list">
                <li>Republish material from the platform</li>
                <li>Sell, rent or <span className="gold-accent">sub-license</span> material</li>
                <li>Reproduce, duplicate or copy material</li>
            </ul>

            <h3 className="meta-label-lg gold-accent">Content Liability</h3>
            <p className="terms-text">
                We shall not be held responsible for any content that appears on your Website. 
                You agree to protect and <span className="teal-accent">defend</span> us against all claims.
            </p>

            <h3 className="meta-label-lg gold-accent">Disclaimer</h3>
            <p className="terms-text">
                To the maximum extent permitted by applicable law, we exclude all 
                representations, <span className="teal-accent">warranties</span> and conditions.
            </p>
            
            <ul className="terms-list">
                <li>Limit or exclude our or your liability for <span className="gold-accent">death or personal injury</span>;</li>
                <li>Limit or exclude liability for fraud or <span className="gold-accent">fraudulent misrepresentation</span>;</li>
                <li>Limit any liabilities in any way that is not permitted under applicable law.</li>
            </ul>
        </div>
    );
}
 
export default Terms;